const userInputDiffersFromFormattedValue = (input, formatted, cursorPosition) => input.substring(0, cursorPosition) !== formatted.substring(0, cursorPosition);

const isUntouchedPrePopField = (input, formatted, cursorPosition) => (cursorPosition === 0 && formatted.length > 0 && input.length === 0);

const characterAtCursorPositionIsDash = (text, cursorPosition) => text.charAt(cursorPosition - 1) === '-';

const textAfterNewCursorPositionIsDash = (text, cursorPosition) => text.substring(cursorPosition) === '-';

export const getCursorPosition = (inputText, formattedText, oldCursorPosition) => {
  let newCursorPosition = 0;
  if (userInputDiffersFromFormattedValue(inputText, formattedText, oldCursorPosition)) {
    newCursorPosition = oldCursorPosition + formattedText.length - inputText.length;

    if (characterAtCursorPositionIsDash(formattedText, oldCursorPosition)) {
      newCursorPosition += 1;
    }

  } else if (isUntouchedPrePopField(inputText, formattedText, oldCursorPosition)) {
    newCursorPosition = oldCursorPosition + formattedText.length - inputText.length;

  } else {
    newCursorPosition = oldCursorPosition;
  }

  if (textAfterNewCursorPositionIsDash(formattedText, newCursorPosition)) {
    newCursorPosition += 1;
  }

  return newCursorPosition;
};
